let isTouchCache = undefined;
import cloneDeep from 'lodash/cloneDeep';
/**
 * Test if browser is touch screen
 *
 * @returns boolean
 */ export function isTouch() {
    if (typeof window === 'undefined') {
        return false;
    }
    if (isTouchCache !== undefined) {
        return isTouchCache;
    }
    isTouchCache = window.matchMedia('(hover: none), (pointer: coarse)').matches;
    return isTouchCache;
}
/**
 * Cleans href or src value so it only allows http and mailto
 *
 * @param linkOrSrc
 * @returns
 */ export function cleanLinkSrc(linkOrSrc) {
    if (!/^(http|https|mailto):\/\//.test(linkOrSrc !== null && linkOrSrc !== void 0 ? linkOrSrc : '')) {
        return '';
    }
    return linkOrSrc;
}
export function isAndroid() {
    return navigator.userAgent.toLowerCase().indexOf('android') > -1;
}
export function cloneObject(obj) {
    if (typeof structuredClone === 'function') {
        return structuredClone(obj);
    } else {
        return cloneDeep(obj);
    }
}

//# sourceMappingURL=browser.js.map